
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2AnimDialog } from "./Poker2AnimDialog";
import { Poker2LevelUpAnimDialogProperties } from "./Poker2LevelUpAnimDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2LevelUpAnimDialog extends Poker2AnimDialog {
    public static NAME: string = "Poker2LevelUpAnimDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        super.applyProperties();
        this.levelupDialog.btn_okay.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        this.levelupDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_levelup_title");
        this.levelupDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_levelup_copy");
        this.levelupDialog.txt_level.text = NumberStringHelper.groupString(Poker2Model.userData.userLevel, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.levelupDialog.txt_chips_value.text = "x" + NumberStringHelper.groupString(this.bonusDialogProperties.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.levelupDialog.txt_gold_value.text = "x" + NumberStringHelper.groupString(this.bonusDialogProperties.gold, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.levelupDialog.btn_okay:
                this.hide();
                break;
        }
    }

    protected get bonusDialogProperties(): Poker2LevelUpAnimDialogProperties {
        return this.properties as Poker2LevelUpAnimDialogProperties;
    }

    protected get levelupDialog(): Library.PokerPopUps.PokerLevelUp {
        return this.disp as Library.PokerPopUps.PokerLevelUp;
    }
}
